function u(r, n) {
  return new Promise(function(t, o) {
    var e = setTimeout(function() {
      o(Error("Promise timed out"));
    }, n);
    r.then(function(i) {
      return clearTimeout(e), t(i);
    }).catch(o);
  });
}
function c(r) {
  return new Promise(function(n) {
    return setTimeout(n, r);
  });
}
function a(r, n, t) {
  var o = function() {
    try {
      return Promise.resolve(n(r));
    } catch (e) {
      return Promise.reject(e);
    }
  };
  return c(t).then(function() {
    return u(o(), 1e3);
  }).catch(function(e) {
    r?.log("warn", "Callback Error", { error: e }), r?.stats.increment("callback_error");
  }).then(function() {
    return r;
  });
}
export {
  a as invokeCallback,
  u as pTimeout,
  c as sleep
};
//# sourceMappingURL=index72.js.map
